import { RepositoryFactory } from '@/api/RepositoryFactory'
const Pole = RepositoryFactory.get('pole')

import { formattedNumberDecimal } from '@/helpers/functions'
import { getDateOfCertainFormat } from '@/helpers/date'
import { preparePagination } from '@/helpers/store'

import {
  FETCH_POLE_BIDS,
  FETCH_POLE_COEFFICIENTS,
  FETCH_POLE_QUANTITY,
  FETCH_POLE_STATUSES,
  GET_POLE_BIDS,
  GET_POLE_COEFFICIENTS,
  GET_POLE_COEFFICIENTS_LOADING,
  GET_POLE_COEFFICIENTS_PAGINATION,
  GET_POLE_LOADING,
  GET_POLE_PAGINATION,
  GET_POLE_QUANTITY,
  GET_POLE_STATUSES,
  SET_POLE_BIDS,
  SET_POLE_COEFFICIENTS,
  SET_POLE_COEFFICIENTS_LOADING,
  SET_POLE_LOADING,
  SET_POLE_QUANTITY,
  SET_POLE_STATUSES,
  UPDATE_POLE_BID,
  UPDATE_POLE_COEFFICIENT,
} from './actions/pole'

export default {
  namespaced: true,
  state: {
    bids: [],
    statuses: [],
    quantity: 0,
    pagination: {},
    loading: false,
    coefficients: [],
    coefficientsPagination: {},
    coefficientsLoading: false,
  },
  getters: {
    [GET_POLE_BIDS](state) {
      return state.bids
    },
    [GET_POLE_LOADING](state) {
      return state.loading
    },
    [GET_POLE_PAGINATION](state) {
      return state.pagination
    },
    [GET_POLE_QUANTITY](state) {
      return state.quantity
    },
    [GET_POLE_STATUSES](state) {
      return state.statuses
    },
    [GET_POLE_COEFFICIENTS](state) {
      return state.coefficients
    },
    [GET_POLE_COEFFICIENTS_LOADING](state) {
      return state.coefficientsLoading
    },
    [GET_POLE_COEFFICIENTS_PAGINATION](state) {
      return state.coefficientsPagination
    },
  },
  actions: {
    // получение список заявок по ПОЛЮ.РФ
    [FETCH_POLE_BIDS]({ commit }, payload) {
      commit(SET_POLE_LOADING, true)

      Pole.fetchPoleBids(payload)
        .then(res => {
          commit(SET_POLE_BIDS, res)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_POLE_LOADING, false))
    },

    // получение количества новых заявок
    [FETCH_POLE_QUANTITY]({ commit }) {
      Pole.getBidsQuantity()
        .then(res => {
          commit(SET_POLE_QUANTITY, res.data.result)
        })
        .catch(e => console.log(e))
    },

    // получение справочника статусов
    [FETCH_POLE_STATUSES]({ commit }) {
      Pole.fetchPoleStatuses()
        .then(res => {
          commit(SET_POLE_STATUSES, res.data)
        })
        .catch(e => console.log(e))
    },

    // изменение статуса и/или комментария заявки
    [UPDATE_POLE_BID]({ commit, dispatch }, { bid, params }) {
      commit(SET_POLE_LOADING, true)

      Pole.updatePoleBid(bid)
        .then(() => {
          dispatch(FETCH_POLE_QUANTITY)
          dispatch(FETCH_POLE_BIDS, params)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_POLE_LOADING, false))
    },

    // получение существующих коэффициентов стоимости
    [FETCH_POLE_COEFFICIENTS]({ commit }, payload) {
      commit(SET_POLE_COEFFICIENTS_LOADING, true)

      Pole.fetchCoefficients(payload)
        .then(res => {
          commit(SET_POLE_COEFFICIENTS, res)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_POLE_COEFFICIENTS_LOADING, false))
    },

    // изменение значения коэффициента стоимости
    [UPDATE_POLE_COEFFICIENT]({ commit, dispatch }, { data, params }) {
      commit(SET_POLE_COEFFICIENTS_LOADING, true)

      Pole.updateCoefficient(data)
        .then(() => {
          dispatch(FETCH_POLE_COEFFICIENTS, params)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_POLE_COEFFICIENTS_LOADING, false))
    },
  },
  mutations: {
    [SET_POLE_LOADING]: (state, payload) => {
      state.loading = payload
    },
    [SET_POLE_COEFFICIENTS_LOADING]: (state, payload) => {
      state.coefficientsLoading = payload
    },
    [SET_POLE_BIDS]: (state, payload) => {
      state.bids = payload.data
      state.bids.forEach(bid => {
        bid.distance = formattedNumberDecimal(bid.distance / 1000) + ' км'
        bid.total_price = formattedNumberDecimal(bid.total_price / 100) + ' ₽'
        bid.price_per_ton =
          formattedNumberDecimal(bid.price_per_ton / 100) + ' ₽'
        bid.order_date = getDateOfCertainFormat(bid.order_date, 'DD/MM/YYYY')
        bid.created_at = getDateOfCertainFormat(bid.created_at, 'DD/MM/YYYY')
      })
      state.pagination = preparePagination(payload.headers)
    },
    [SET_POLE_QUANTITY]: (state, payload) => {
      state.quantity = payload
    },
    [SET_POLE_STATUSES]: (state, payload) => {
      state.statuses = payload
    },
    [SET_POLE_COEFFICIENTS]: (state, payload) => {
      state.coefficients = payload.data
      state.coefficients.forEach(item => {
        item.min_distance += ' км'
        item.max_distance += ' км'
        item.price_per_ton += ' руб/т'
      })
      state.coefficientsPagination = preparePagination(payload.headers)
    },
  },
}
